import React, { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {}

export const BarsContainer: FC<Props> = ({ children }) => {
  return <div className="chartContent">{children}</div>;
};
